import React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import clsx from "clsx";
import styles from "./CustomButton.module.css";

type Intent = "primary"; // | "success" | "warning" | "danger";
type Size = "small" | "default" | "large";
type Variant = "filled" | "outlined" | "minimal" | "text";

interface CustomButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  intent?: Intent;
  size?: Size;
  variant?: Variant;
  loading?: boolean;
  icon?: React.ElementType;
  rightIcon?: React.ElementType;
  rounded?: boolean;
}

const CustomButton: React.FC<CustomButtonProps> = ({
  intent = "",
  size = "default",
  variant = "filled",
  loading = false,
  icon: Icon,
  rightIcon: RightIcon,
  children,
  disabled,
  rounded,
  className,
  ...rest
}) => {
  return (
    <button
      className={clsx(
        styles.button,
        styles[intent],
        styles[size],
        styles[variant],
        { [styles.loading]: loading, [styles.rounded]: rounded },
        className,
      )}
      disabled={disabled || loading}
      {...rest}
    >
      {loading ? (
        <CircularProgress size={16} color="inherit" />
      ) : (
        <>
          {Icon && (
            <Icon
              className={clsx(styles.icon, styles.iconLeft, styles[intent])}
            />
          )}
          <span>{children}</span>
          {RightIcon && (
            <RightIcon
              className={clsx(styles.icon, styles.iconRight, styles[intent])}
            />
          )}
        </>
      )}
    </button>
  );
};

export default CustomButton;
